// actions/auth/getPlayer.ts
//
// ВИПРАВЛЕНО:
//  1. dispatch йшов в ConfirmOTPActionTypes — тепер використовує PlayerActionTypes
//  2. withCredentials: true → Authorization: Bearer header (захищений ендпоінт /api/identify)
//     accessToken передається параметром, щоб action залишався pure і testable

import { Dispatch } from "redux";
import { PlayerActionTypes, PlayerCreateAction } from "../../types/auth/playerData";
import axios from "axios";

interface ErrorResponse {
    code: number;
    message: string;
}

export const getPlayerData = (accessToken: string) => {
    return async (dispatch: Dispatch<PlayerCreateAction>) => {
        try {
            dispatch({ type: PlayerActionTypes.GET_PLAYER_DATA });

            const response = await axios({
                method: 'get',
                url: `/api/identify`,
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
                withCredentials: false,
            });

            dispatch({
                type: PlayerActionTypes.GET_PLAYER_DATA_SUCCESS,
                payload: response.data ?? response.status,
            });

        } catch (error: any) {
            let errorPayload: ErrorResponse;

            if (error.response?.data) {
                errorPayload = typeof error.response.data === 'string'
                    ? { code: error.response.status, message: error.response.data }
                    : { code: error.response.data.code, message: error.response.data.message };
            } else {
                errorPayload = { code: -1, message: 'Unknown error occurred' };
            }

            dispatch({ type: PlayerActionTypes.GET_PLAYER_DATA_ERROR, payload: errorPayload });
        }
    };
};